import useScreenSize, { useCustomScreenSize } from "hoc/useScreenSize";
import { DEFAULT_CATEGORY_BANNER } from "modules/site-structure/common/make-model-year-utils";
import Head from "next/head";
import Image from "next/legacy/image";
import { FC, useState, useEffect } from "react";
import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";
import styles from "./responsiveBanner.module.scss";
export interface IScreenData {
    url: string;
    height: number;
    alt: string;
}

export interface IResponsiveMediaData {
    desktop: string;
    mobile: string;
    tablet: string;
}
export interface IProps {
    bannerImages?: IResponsiveMediaData | null;
    desktopWidth?: number;
    desktopHeight?: number;
}

const BannerImagesV2: FC<IProps> = ({
  bannerImages, desktopWidth, desktopHeight,
}) => {
  if (!bannerImages) {
    return null;
  }

  const [isMobile, isTablet, isDesktop] = useScreenSize();

  const smallMobile = useCustomScreenSize({
    maxWidth: 424,
  });

  const smallTablet = useCustomScreenSize({
    minWidth: 425,
    maxWidth: 991,
  });

  const ImageComponent = ({
    fallbackImage,
  }: any) => {
    const [isError, sethasError] = useState(false);
    useEffect(() => {
      sethasError(false);
    }, [bannerImages.mobileImage || bannerImages.tabletImage || bannerImages.desktopImage]);

    let headTagImageUrl = bannerImages.mobileImage;

    if (isDesktop) {
      headTagImageUrl = bannerImages.desktopImage;
    } else if (smallTablet) {
      headTagImageUrl = bannerImages.tabletImage;
    }

    let alt = "";

    const getMedia = (key: keyof IResponsiveMediaData) => {
      alt = bannerImages[key]?.split(".webp")[0]?.split("/").pop();
    };

    if (isMobile) {
      getMedia("mobileImage");
    } else if (isTablet) {
      getMedia("tabletImage");
    } else if (isDesktop) {
      getMedia("desktopImage");
    }

    return (
      <>
        <Head>
          <link rel="preload" as="image" href={getRelativeImagePath(headTagImageUrl)} />
        </Head>
        {smallMobile && (
          <div className={styles.mobile_view}>

            <img
              className="banner_video"
              onError={() => sethasError(true)}
              src={!isError ? getRelativeImagePath(bannerImages.mobileImage) : fallbackImage || DEFAULT_CATEGORY_BANNER}
              style={{ objectFit: "contain", width: "100%" }}
              alt={alt}
            />

          </div>
        )}

        {
          smallTablet && (
            <div>
              <Image
                layout="responsive"
                unoptimized
                src={!isError ? getRelativeImagePath(bannerImages.tabletImage) : fallbackImage || DEFAULT_CATEGORY_BANNER}
                alt={alt}
                height={150}
                width={643}
                onError={() => sethasError(true)}
              />
            </div>
          )
        }

        {
          isDesktop && (
            <div className={styles.desktop_view}>
              <Image
                layout="responsive"
                unoptimized
                src={!isError ? getRelativeImagePath(bannerImages.desktopImage) : fallbackImage || DEFAULT_CATEGORY_BANNER}
                alt={alt}
                height={desktopHeight || 150}
                width={desktopWidth || 1140}
                onError={() => sethasError(true)}
              />
            </div>
          )
        }

        {/* <img
        className={`banner_video ${imageClassName}`}

        src={!isError ? src : fallbackImage || DEFAULT_CATEGORY_BANNER}
        style={{ objectFit: "contain", height: "calc(20 * var(--safari-root-font, 10px))", width: "100%" }}
        alt={imageAlt}
      /> */}
      </>
    );
  };
  return (
    <ImageComponent
      fallbackImage={DEFAULT_CATEGORY_BANNER}
    />
  );
};

export default BannerImagesV2;
